module.exports = __webpack_public_path__ + "img/01web-ancora.58f7c1e2.png";